// 🔴 P1 — « Enregistrer sur le téléphone » : copie EXPLICITE d'une photo prise, dans la galerie / les fichiers du téléphone.
//
// ⚠️ Une PWA ne peut PAS écrire silencieusement dans la galerie. Le plus petit mécanisme fiable : la feuille de PARTAGE du système (Web Share API avec fichier ⇒ iOS « Enregistrer l'image »,
// Android « Enregistrer / Photos »), sinon un téléchargement. ⛔ On n'affiche JAMAIS « enregistré dans la galerie » sans certitude : le navigateur ne dit pas ce que l'utilisateur a choisi dans la
// feuille de partage ; les messages décrivent ce qui s'est PASSÉ, pas ce qu'on espère. (Sur Android, la capture par l'appli appareil photo enregistre en général elle-même dans la galerie : à constater.)
// Accepte UN fichier ou une LISTE (« Tout enregistrer » : une seule feuille de partage pour toutes les photos de la visite).
export async function enregistrerSurLeTelephone(entree) {
  const fichiers = (Array.isArray(entree) ? entree : [entree]).filter(Boolean);
  if (!fichiers.length) return { etat: "echec", message: "Aucune photo à copier." };
  const fichier = fichiers[0];
  try {
    if (typeof navigator !== "undefined" && typeof navigator.share === "function" && typeof navigator.canShare === "function" && navigator.canShare({ files: fichiers })) {
      await navigator.share({ files: fichiers, title: fichier.name || "photo" });
      return { etat: "partage", message: "Feuille de partage ouverte : choisissez « Enregistrer l'image » (ou Photos) pour la garder sur le téléphone." };
    }
  } catch (err) {
    if (err && err.name === "AbortError") return { etat: "annule", message: "Copie annulée : la photo reste envoyée dans la visite." };
    // autre échec du partage ⇒ repli téléchargement ci-dessous
  }
  try {
    for (const f of fichiers) {
      const url = URL.createObjectURL(f);
      const a = document.createElement("a");
      a.href = url; a.download = f.name || "photo.jpg"; a.rel = "noopener";
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    }
    return { etat: "telecharge", message: fichiers.length > 1
      ? `${fichiers.length} fichiers téléchargés : cherchez-les dans les Téléchargements du téléphone (ils ne sont pas forcément dans la galerie).`
      : "Fichier téléchargé : cherchez-le dans les Téléchargements du téléphone (il n'est pas forcément dans la galerie)." };
  } catch {
    return { etat: "echec", message: "Impossible de copier la photo sur ce téléphone : elle reste bien envoyée dans la visite." };
  }
}
